import styled from 'styled-components';

export const Container = styled.main`
	display: flex;
	width: 100%;
	flex-direction: column;
	${({ bgColor }) => bgColor ? `background-color: ${bgColor}` : ''};
`;
